// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification-bell-icon{width:24px;height:24px;position:relative;top:7px;right:10px}.notification-bell-icon path{fill:#fff!important}", ""]);
// Exports
module.exports = exports;
